import { VenueV2Form } from "./VenueV2Form";

export default VenueV2Form;
